// API Configuration
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_SERVER_URL || 'https://lindu-api-v2-fggaf2ahakhjffah.canadacentral-01.azurewebsites.net',
    ENDPOINTS: {
        // Auth endpoints
        LOGIN: '/login',
        CLIENT_SELF: '/api/cliente/self',
        ESTABLISHMENT_SELF: '/api/estabelecimento/self',
        ESTABLISHMENT: '/api/estabelecimento',

        // Services endpoints
        SERVICES: '/api/servicos',
        APPOINTMENTS: '/api/servicos/agendamento',
        CLIENT_APPOINTMENTS: '/api/servicos/clientes-agendamentos',
        CLIENT_APPOINTMENTS_V2: '/api/servicos/clientes-agendamentos-v2',

        // Professional endpoints
        PROFESSIONALS: '/api/profissionais-estabelecimento',

        // Product endpoints
        PRODUCTS: '/api/products',

        // Client endpoints
        CLIENT_PRE: '/api/cliente/pre',

        // Portfolio endpoints
        PORTFOLIO_ADD_IMAGE: '/api/estabelecimento/add/image',
        PORTFOLIO_GET_IMAGE: '/api/estabelecimento/get/image',
    }
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint, params = {}) => {
    let url = `${API_CONFIG.BASE_URL}${endpoint}`;

    // Replace path parameters
    Object.keys(params).forEach(key => {
        url = url.replace(`:${key}`, params[key]);
    });

    return url;
};

// Helper function to get full endpoint URL
export const getApiUrl = (endpoint) => `${API_CONFIG.BASE_URL}${endpoint}`;
